import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { DdcUserSubscription } from '../../models/main/subscription'
import { DdcButtonFollowComponent } from '../ddc-button-follow/ddc-button-follow.component'
import { DdcDualLngComponent } from '../ddc-dual-lng/ddc-dual-lng.component'

@Component({
  selector: 'ddc-user-profile-card',
  templateUrl: './ddc-user-profile-card.component.html',
  styleUrls: ['./ddc-user-profile-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatCardModule,
    DdcButtonFollowComponent,
    DdcDualLngComponent,
  ],
})
export class DdcUserProfileCardComponent {
  @Input() _userProfilePic!: string
  @Input() _isOwnProfile!: boolean
  @Input() _isFollowed!: boolean
  @Input() _username!: string
  @Input() _bio?: string
  @Input() _country?: string
  @Input() _city?: string
  @Input() _favLanguage1?: string
  @Input() _favLanguage2?: string
  @Input() _favLanguage3?: string
  @Input() _subscription!: DdcUserSubscription
  @Input() _isVerified?: boolean = false
  @Input() _dics_count?: number
  @Input() _followers_count?: number
  @Input() _following_count?: number
  @Input() _pairs_count?: number
  @Input() _words_count?: number

  @Output() followToggle = new EventEmitter<boolean>()
  @Output() editProfilePicture = new EventEmitter<void>()

  onFollowToggle(event: boolean): void {
    this.followToggle.emit(event)
  }

  openProfilePictureDialog(): void {
    this.editProfilePicture.emit()
  }
}
